export default "__VITE_ASSET__BFXYT4Vv__"